function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M24 46.498C36.4264 46.498 46.5 36.4245 46.5 23.998C46.5 11.5716 36.4264 1.49805 24 1.49805C11.5736 1.49805 1.5 11.5716 1.5 23.998C1.5 36.4245 11.5736 46.498 24 46.498Z",
  fill: "#FCE8E9"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M24.15 33C23.8237 33 23.5047 33.0968 23.2333 33.2781C22.962 33.4594 22.7505 33.7171 22.6256 34.0186C22.5007 34.3201 22.468 34.6518 22.5317 34.9719C22.5954 35.292 22.7525 35.586 22.9833 35.8167C23.214 36.0475 23.508 36.2046 23.8281 36.2683C24.1482 36.332 24.4799 36.2993 24.7814 36.1744C25.0829 36.0495 25.3406 35.838 25.5219 35.5667C25.7032 35.2954 25.8 34.9763 25.8 34.65C25.8 34.2124 25.6262 33.7927 25.3167 33.4833C25.0073 33.1738 24.5876 33 24.15 33Z",
  fill: "#EB636B"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M24 28.5V13.5",
  stroke: "#EB636B",
  strokeWidth: 3,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

function SvgCheckCircleError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleError);
export default __webpack_public_path__ + "static/media/check-circle-error.5d570c3a.svg";
export { ForwardRef as ReactComponent };